import { render, staticRenderFns } from "./Offshore2.vue?vue&type=template&id=8211518e&"
import script from "./Offshore2.vue?vue&type=script&lang=js&"
export * from "./Offshore2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports